<template>
    <v-container>
      <vueHeadful
      :title="this.$i18n.t('Menu.SoporteOficina') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="12" style="padding: 5% 20%;">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete v-model="tipoSolicitud" :items="solicitudes" item-text="titulo" item-value="id" :label="$t('Oficina.TipoSolicitud')" solo />
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="descripcionSoporte" :label="$t('Oficina.Descripcion')" solo />
                </v-col>
                <v-col cols="12">
                  <v-btn @click="soporte" block color="primary">{{$t('Oficina.EnviarSoporte')}}</v-btn>
                </v-col>
              </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'SoporteOficina',
  data () {
    return {
      tipoSolicitud: '',
      solicitudes: [
        { titulo: this.$i18n.t('Oficina.Ventas'), id: 'ventas' }
      ],
      descripcionSoporte: ''
    }
  },
  methods: {
    soporte () {

    }
  }
}
</script>
